import { Modal } from '@kathondvla/react-shared-components/src/components';
import { checkHasDerived, getCurriculaCustIds } from '@utils/homeHelper';

import './modals.scss';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';
import { selectCalendarExistsForCurriculum } from '@store/calendar/calendarSelectors';
import { selectCustomCurriculaData } from '@store/llinkidApis/llinkidApiSelectors';
import { useDispatch, useSelector } from 'react-redux';

import iconDeleteWhite from '@assets/img/delete_white.svg';
import { trackDeleteLeerplan } from '@store/tracking/trackingSagas';

const DeleteCurriculaModal = ({ curricula, onClose, onConfirm }) => {
  const dispatch = useDispatch();

  const customCurricula = useSelector(selectCustomCurriculaData);

  const custIds = getCurriculaCustIds(curricula, customCurricula);
  const hasDerived = checkHasDerived(custIds, customCurricula);
  const hasCalendar = useSelector((state) => selectCalendarExistsForCurriculum(state, { custIds }));

  const onCloseAction = () => {
    onClose();
    dispatch(
      trackDeleteLeerplan({
        delete: false,
        isNonderived: curricula.id === 'nonderived',
        curriculumType: curricula.type,
      }),
    );
  };

  const onConfirmAction = () => {
    onConfirm({ curricula });
    dispatch(
      trackDeleteLeerplan({
        delete: true,
        isNonderived: curricula.id === 'nonderived',
        curriculumType: curricula.type,
      }),
    );
  };

  let warning = 'Ben je zeker dat je dit leerplan wil verwijderen?';
  if (hasCalendar)
    warning =
      'Je kan dit leerplan niet verwijderen. Verwijder eerst alle vorderingsplannen gebaseerd op dit leerplan.';
  if (hasDerived)
    warning = 'Je kan dit leerplan niet verwijderen. Verwijder eerst alle gelinkte leerplannen.';

  return (
    <>
      <Modal.Header title="Leerplan verwijderen?" icon={iconDeleteWhite} onClose={onCloseAction} />
      <Modal.Body>
        <span className="delete-text">{warning}</span>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outlined" onClick={onCloseAction}>
          Annuleren
        </Button>
        {!hasCalendar && !hasDerived && (
          <Button variant="contained" onClick={onConfirmAction}>
            <DeleteIcon />
            Verwijderen
          </Button>
        )}
      </Modal.Footer>
    </>
  );
};

export default DeleteCurriculaModal;
